import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  description: css`
    max-width: 400px;
    max-height: 300px;
    overflow: hidden;
    white-space: pre-line;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
